export class EditorService {
    
}


// WEBPACK FOOTER //
// ./src/app/common/components/editor/editor.service.js